import { getAmplitudeInstance } from '../amplitudeHelpers';
import CardLocation from '../enums/CardLocation';

type logHikeEventCreateStartedParams = {
  custom_route_id?: number;
  entry_point?: CardLocation;
  trail_id?: number;
};

/**
 * User opens the Hike Event create flow ('Schedule your hike' / 'Create an invite' on web). Fires when the entry screen of the create flow appears, regardless of whether the user completes creation.
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_id - Id of the custom route associated with the event.
 * @param params.entry_point - Surface where the user initiated the create flow from (e.g., 'trail details' for the action sheet on iOS or the share menu on web).
 * @param params.trail_id - Id of the trail associated with the event.
 */
const logHikeEventCreateStarted = ({ custom_route_id, entry_point, trail_id }: logHikeEventCreateStartedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'hike event create started',
    { 'custom route id': custom_route_id, 'entry point': entry_point, 'trail id': trail_id },
    callback
  );
};

export default logHikeEventCreateStarted;
